// @ts-nocheck
// This file is generated by Umi automatically
// DO NOT CHANGE IT MANUALLY!
import WalletOutlined from '/app/node_modules/.pnpm/@ant-design+icons@4.7.0_react-dom@19.2.7_react@19.2.7__react@19.2.7/node_modules/@ant-design/icons/es/icons/WalletOutlined';
import DashboardOutlined from '/app/node_modules/.pnpm/@ant-design+icons@4.7.0_react-dom@19.2.7_react@19.2.7__react@19.2.7/node_modules/@ant-design/icons/es/icons/DashboardOutlined';
import AuditOutlined from '/app/node_modules/.pnpm/@ant-design+icons@4.7.0_react-dom@19.2.7_react@19.2.7__react@19.2.7/node_modules/@ant-design/icons/es/icons/AuditOutlined';
export default { WalletOutlined, DashboardOutlined, AuditOutlined };
